import {ItemData, pendingGeomIds} from "../worker/RenderWorker.ts";

/* see docs/EXTRACTED_COMMENTS.md#c208 */
export class RenderTraversalUtils {
    /* see docs/EXTRACTED_COMMENTS.md#c209 */
    /* see docs/EXTRACTED_COMMENTS.md#c793 */
    static hasPendingDescendant(id: string, pending: Set<string> = pendingGeomIds): boolean {
        return pending.has(id);
    }

    /* see docs/EXTRACTED_COMMENTS.md#c583 */
    static visibleChildren(item: ItemData, items: Map<string, ItemData>): ItemData[] {
        return [...item.children]
            .map((child) => items.get(child))
            .filter((c): c is ItemData => !!c)
            .filter(
                (c) =>
                    !(
                        c.hide_flags.data ||
                        c.hide_flags.rule ||
                        c.hide_flags.image ||
                        c.hide_flags.alternating ||
                        c.hide_flags.anchoring ||
                        c.hide_flags.render ||
                        c.hide_flags.dedup ||
                        c.hide_flags.playlist ||
                        c.hide_flags.countdown ||
                        c.hide_flags.children
                    )
            );
    }

    /* see docs/EXTRACTED_COMMENTS.md#c584 */
    static sizingChildren(item: ItemData, items: Map<string, ItemData>): ItemData[] {
        return [...item.children]
            .map((child) => items.get(child))
            .filter((c): c is ItemData => !!c)
            .filter((c) => {
                // Author intent and renderer geometry always collapse a child out of sizing.
                if (c.hide_flags.rule) return false;
                if (c.hide_flags.anchoring) return false;
                if (c.public_hide_flags.render) return false; /* Experimental fix */
                // An alternating-hidden child is only waiting for its turn: it still counts, so a
                // CHILD-sized container fits its largest alternative instead of resizing each swap.
                return !(
                    c.hide_flags.data ||
                    c.hide_flags.image ||
                    c.hide_flags.dedup ||
                    c.hide_flags.playlist ||
                    c.hide_flags.countdown ||
                    c.hide_flags.children
                );
            });
    }

    /* see docs/EXTRACTED_COMMENTS.md#c585 */
    private static bestDimension(geometry: number, measured: number | undefined, original: number): number {
        if (geometry > 0) return geometry;
        if (measured != null && measured > 0) return measured;
        if (original > 0) return original;
        return 0;
    }

    private static bestOffset(geometry: number, original: number): number {
        return (Number.isFinite(geometry) ? geometry : undefined) ??
            (Number.isFinite(original) ? original : undefined) ??
            0;
    }


    static maxChildWidthWithOffset(children: ItemData[]) {
        const maxRightEdge = Math.max(
            0,
            ...children.map((c) => {
                const w = this.bestDimension(
                    c.geometry.width,
                    c.measuredWidth,
                    c.geometry.original.width,
                );
                const x = this.bestOffset(c.geometry.x, c.geometry.original.x);
                return x + w;
            })
        );
        return {maxWidth: maxRightEdge, maxXOffset: 0};
    }

    static maxChildHeightWithOffset(children: ItemData[]) {
        const maxBottomEdge = Math.max(
            0,
            ...children.map((c) => {
                const h = this.bestDimension(
                    c.geometry.height,
                    c.measuredHeight,
                    c.geometry.original.height,
                );
                const y = this.bestOffset(c.geometry.y, c.geometry.original.y);
                return y + h;
            })
        );
        return {maxHeight: maxBottomEdge, maxYOffset: 0};
    }
}
